import api from "@/lib/api";
import type { ApiDilemma } from "@/features/dilemmas/types";
import type { AiGenerateRequest, AiRefineRequest } from "../types";

// generate/refine call Mistral and can take up to 60s:
// override the global timeout (10s) for these requests.
const AI_REQUEST_TIMEOUT_MS = 60000;

const AI_WRITING_ASSISTANT_ENDPOINTS = {
  GENERATE: "/dilemmas/generate/",
  REFINE: (id: string) => `/dilemmas/${id}/refine/`,
};

export class AiWritingAssistantHttpRepository {
  async generate(payload: AiGenerateRequest): Promise<ApiDilemma> {
    const result = await api.post(
      AI_WRITING_ASSISTANT_ENDPOINTS.GENERATE,
      payload,
      { timeout: AI_REQUEST_TIMEOUT_MS },
    );
    return result.data;
  }

  async refine(id: string, payload: AiRefineRequest): Promise<ApiDilemma> {
    const result = await api.patch(
      AI_WRITING_ASSISTANT_ENDPOINTS.REFINE(id),
      payload,
      { timeout: AI_REQUEST_TIMEOUT_MS },
    );
    return result.data;
  }
}
